import { Injectable } from '@angular/core';
import { RoutingService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CurrentItemService } from '@spartacus/organization/administration/components';
import { UigB2BUserService } from '../uig-b2b-user/uig-b2b-user.service';
import { ROUTE_PARAMS } from '../../uig-organization.model';
import { UigB2BUser } from '../../uig-user/uig-user.model';

@Injectable({
  providedIn: 'root'
})
export class UigCurrentUserService extends CurrentItemService<UigB2BUser> {
  readonly name$: Observable<string> = this.item$.pipe(
    map((user: UigB2BUser) => user.name)
  );

  constructor(
    protected routingService: RoutingService,
    protected uigB2BUserService: UigB2BUserService
  ) {
    super(routingService);
  }

  protected getParamKey() {
    return ROUTE_PARAMS.userCode;
  }

  protected getItem(code: string): Observable<UigB2BUser> {
    return this.uigB2BUserService.get(code);
  }

  getError(code: string): Observable<boolean> {
    return this.uigB2BUserService.getErrorState(code);
  }
}
